import React from 'react';
import {getGradients} from '../../util/ChartsUtil';
import {useIntl} from 'react-intl';
import {Chart} from 'web-components';
import {BUDGET_TYPE} from '../../../../../../constants';

const ProfitChart = ({project, data, hasBaseline, eyeOptionMap, modifyChartOptions}) => {
	const intl = useIntl();
	const {formatMessage} = intl;
	const isFixedPriceProject = [BUDGET_TYPE.FIXED_PRICE, BUDGET_TYPE.FIXED_PRICE_V2].includes(project.budgetType);
	const isEstimatedInPoints = project.estimationUnit === 'POINTS';
	const {actualProfitChartData, plannedProfitChartData, forecastProfitChartData, baselineProfitChartData, fixedPriceChartData} = data;
	const {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual, gradientStrokeBaseline, gradientStrokeFixedPrice} = getGradients();
	const dataSets = [];

	if (isFixedPriceProject && fixedPriceChartData.length > 0) {
		dataSets.push({
			name: formatMessage({id: 'common.fixed_price'}),
			color: gradientStrokeFixedPrice,
			backgroundColor: '#fff',
			data: fixedPriceChartData,
		});
	}

	if (hasBaseline && eyeOptionMap.baseline) {
		dataSets.push({
			name: formatMessage({id: 'baseline.baseline'}),
			color: gradientStrokeBaseline,
			filled: true,
			backgroundColor: 'transparent',
			data: baselineProfitChartData,
			dashed: true,
		});
	}

	if (!isEstimatedInPoints && eyeOptionMap.plan) {
		dataSets.push({
			name: formatMessage({id: 'project_budget.planned_profit'}),
			color: gradientStroke,
			filled: true,
			backgroundColor: gradientFill,
			data: plannedProfitChartData,
		});
	}
	if (eyeOptionMap.actual) {
		dataSets.push({
			name: formatMessage({id: 'project_budget.actual_profit'}),
			color: gradientStrokeActual,
			filled: true,
			backgroundColor: gradientFillActual,
			data: actualProfitChartData,
		});
	}

	if (forecastProfitChartData.length && eyeOptionMap.forecast) {
		dataSets.push({
			name: formatMessage({id: 'common.forecast'}),
			color: gradientStrokeActual,
			filled: true,
			backgroundColor: 'transparent',
			dashed: true,
			data: forecastProfitChartData,
		});
	}

	return <Chart dataSets={dataSets} modifyOptions={modifyChartOptions} />;
};

export default ProfitChart;
